.profile-container {
  padding: 20px;
  background-color:var(--bg-primary-color);
}

.profile-header {
  font-size: 24px;
  font-weight: 500;
  margin-left: 10px;
}

.photo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  position: relative;
}

.profile-photo {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background-color: var(--bg-incoming-message);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.photo-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.photo-wrapper:hover .hover-overlay {
  opacity: 1;
}

.photo-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.camera-icon {
  background-color: var( --bg-incoming-message);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}

.camera-icon svg {
  color: var(--text-incoming-message);
  width: 22px;
  height: 22px;
}

.add-text, .change-text {
  font-size: 12px;
  text-align: center;
  padding: 0 15px;
  color: var(--text-incoming-message);
}

.form-group {
  margin-bottom: 30px;
}

.label {
  font-size: 14px;
  color: var( --bg-primary-light);
  margin-bottom: 10px;
  display: block;
}

.input-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--text-outgoing-message);;
  padding-bottom: 10px;
}

.input-text {
  font-size: 16px;
  color: var(--text-outgoing-message);
}

.edit-button {
  background: none;
  border: none;
  cursor: pointer;
  color: var( --text-secondary-color);
  padding: 5px;
}

.helper-text {
  font-size: 12px;
  color: var( --text-secondary-color);
  margin-top: 8px;
}

.file-input {
  display: none;
}

.name-input {
  background: none;
  border: none;
  color: var(--text-outgoing-message);
  font-size: 16px;
  width: 100%;
  padding: 0;
  outline: none;
}

.upload-progress {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.d-flex{
  display: flex;
}
.flex-direction-column{
  flex-direction: column;
}
.align-center{
  align-items: center;
}
.spinner-overlay{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.update-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.update-button, .cancel-button {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s, transform 0.1s;
  font-size: 14px;
}

.update-button {
  background-color: var(--bg-incoming-message);
  color: var(--text-incoming-message);
}

.update-button:hover {
  transform: translateY(-1px);
}

.update-button:active {
  transform: translateY(0);
}

.cancel-button {
  background-color: var(--bg-grey-color);
  color: var(--text-outgoing-message);
}

.cancel-button:hover {
  background-color: var(--bg-grey-color);
  transform: translateY(-1px);
}

.cancel-button:active {
  transform: translateY(0);
}

/* Disabled state for buttons */
.update-button:disabled, .cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.header-profile{
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 30px;
}
.header-profile svg{
  display: none;
}

/* Making sure the buttons are responsive */
@media (max-width: 480px) {
  .update-actions {
    flex-direction: column;
  }
  .header-profile svg{
    display: block;
  }
  
  .update-button, .cancel-button {
    width: 100%;
  }
}